import React, { PureComponent } from 'react';
import Selector from 'wt-react/dist/components/Selector/Selector'
import './FundSelector.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  addScreenedFund,
  updateSearchTicker,
} from '../../../actions';
import TickerSelection from '../TickerSelection/TickerSelection';


class FundSelector extends PureComponent {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    // Store the parameters
    this.params = {
      initialTickers: this.props.initialTickers,
      typeaheadUrl: this.props.typeaheadUrl,
      wtRegion: this.props.wtRegion,
      tickerNamesUrl: this.props.tickerNamesUrl,
      showUpload: this.props.showUpload,
      maxFunds: this.props.maxFunds,
    };

    // Handle any initial tickers on load of page
    this.handleInitialTickers();

    // Receive the function to call when the ANALYZE button is pressed
    this.submitFundsToAnalyze = this.props.submitFundsToAnalyze;
    this.tickerSelected = this.props.tickerSelected;

    // Initialize local state
    this.state = {
      selectedFunds: this.props.tickerSearch,
      fundsToCompare: [],
      fundSuggestions: [],
      fundSuggestionsForSelect: [],
      // see explanation of requestIndex below
      counter: 0,
      latestFundSuggestionsRequestIndex: 0,
    };

  }

  //If we update the fundscreen, update the tickers here
  componentDidUpdate(prevProps) {   
    if (prevProps.tickerSearch !== this.props.tickerSearch) {
      this.setState({ selectedFunds: this.props.tickerSearch });
    }
  }

  // Run analysis if tickers are provided to the page
  handleInitialTickers() {
    const {
      initialTickers
    } = this.params;
    // If tickers were passed into the page then load the analysis directly
    if (initialTickers && initialTickers.length > 0) {

      // Check the window's tickers are valid, and if so execute the analysis (uses a promise)
      this.checkTickers(initialTickers)
        .then(() => {
          this.submitFundsToAnalyze(this.state.selectedFunds);
          this.clearSelectedFunds();
        });
    }
  }

  addExternalFund = (fund) => {
    const addFund = {
      value: fund.externalID,
      label: fund.name,
    };
    const selectedFunds = Object.assign([], this.state.selectedFunds);
    selectedFunds.push(addFund);
    this.updateSelectedFunds(selectedFunds);
  }

  // Handle changes to the typed input by the User
  handleInputChange = (newValue) => {
    this.typeahead(newValue);
  };

  // Handle changes to selection
  handleChange =  (selectedFunds) => {
    const id = Math.random().toString(16).substring(2);
    const type = 'ticker';
    const externalID = selectedFunds[0]?.value;
    const name = selectedFunds[0]?.name;
    const ticker = selectedFunds[0]?.ticker;
    const rebalance_fq= 'Quarterly'
    const filteredFund = { id, externalID, ticker, rebalance_fq, name, type };
    if (externalID && name && ticker ) {
      this.props.addScreenedFund(filteredFund);
    }
  };

  // Handle submission of the Funds to analyze
  handleSubmit = () => {
    this.props.submitFundsToAnalyze(this.state.selectedFunds, this.params);
    this.clearSelectedFunds();
  };

  /// Typeahead method to get the top 15 results from DataSpan API
  async typeahead(query) {

    // requestIndex encodes the order at which queries are sent to the server in order
    // to ensure that a long-running query, whose response arrives after a more recent
    // and relevant query has completed, doesn't override the latest query results
    const requestIndex = this.state.counter;
    this.setState({
      counter: this.state.counter + 1,
    });

    if (!query || query.length <= 1) {
      this.loadTypeaheadState(requestIndex, query, []);
      return;
    }

    const url = this.params.typeaheadUrl;

    const data = await fetch(`${url}?q=${encodeURIComponent(query)}&wtRegion=${this.params.wtRegion}`)
      .then((d) => d.json())
      .catch((error) => {
        console.error(error);
        this.loadTypeaheadState(requestIndex, query, []);
      });

    this.loadTypeaheadState(requestIndex, query, Array.isArray(data) ? data : []);

  };

  // Update local state with typeahead data
  loadTypeaheadState(requestIndex, query, payload) {

    // Reject suggestions that aren't relevant by checking requestIndex, which would indicate
    // whether a more recent set of suggestions was already loaded
    if (requestIndex < this.state.latestFundSuggestionsRequestIndex) {
      return;
    }

    if (payload === undefined || payload.length === 0) {
      return;
    }

    const copy = [];

    // Get the current Funds being analyzed
    const fundsToCompare = this.props.currentFunds;

    payload.forEach((item) => {

      // Check if a typeahead result is already being analyzed. Uses externalID
      // as the lookup
      const alreadyInList = fundsToCompare.find(function (externalID) {
        return externalID === item.externalID;
      });

      if (alreadyInList === undefined) {
        copy.push({ 'value': item.externalID, 'label': item.name + ' (' + item.ticker + ')','name': item.name, 'ticker': item.ticker });
      }

    });

    // Update state with updated typeahead results
    this.setState({
      fundSuggestions: payload,
      fundSuggestionsForSelect: copy,
      latestFundSuggestionsRequestIndex: requestIndex,
    });
  }

  // Update the selection bar with the chosen funds from the dropdown
  updateSelectedFunds(selectedFunds) {
    const {
      maxFunds
    } = this.props;
    if (maxFunds > 0 && selectedFunds.length > maxFunds) {
      return;
    }
    this.tickerSelected(selectedFunds);
    this.setState({
      selectedFunds: selectedFunds.length > 0 ? selectedFunds : null,
    },() => {this.props.updateSearchTicker(selectedFunds)});
  }

  // Clear the funds in the selection bar
  clearSelectedFunds() {
    this.setState({
      selectedFunds: null,
      fundSuggestions: [],
      fundSuggestionsForSelect: [],
    });
  }

  async checkTickers(tickers) {
    const {
      maxFunds
    } = this.params;
    if (maxFunds > 0) {
      tickers = tickers.slice(0, maxFunds);
    }
    const url = this.params.tickerNamesUrl;

    const data = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({ tickers }),
      headers: {
        'Content-Type': 'application/json'
      },
    })
      .then((d) => d.json())
      .catch((error) => {
        console.error(error);
      });

    const results = [];

    // Check for unknown funds, and only push those that are found
    data.forEach((fund) => {
      if (fund.name !== 'UNKNOWN') {
        results.push(fund);
      }
    });

    if (results.length === 0) {
      return;
    }

    const selected_funds = [];
    const fundstoCompare = this.state.fundsToCompare.slice();

    results.forEach(function (item) {

      // Check if an excel result is already in the FundList
      const alreadyInList = fundstoCompare.find(function (element) {
        return element.ticker === item.ticker;
      });

      if (alreadyInList === undefined) {
        selected_funds.push({ 'value': item.externalID, 'label': item.name + " (" + item.ticker + ")" });
      }

    });
    this.setState({
      selectedFunds: selected_funds.length > 0 ? selected_funds : null,
    });
  }

  render() {
    const {
      showUpload,
    } = this.params;
    return (
      <div className='row fundselector' id='fund-selector'>
        <div className="col-lg-12 col-md-12 col-sm-12">
          <Selector
            isMulti
            options={this.state.fundSuggestionsForSelect}
            onInputChange={this.handleInputChange}
            onChange={this.handleChange}
            filterOption={false}
            placeholder="SEARCH BY TICKER OR NAME"
            noOptionsMessage={() => null}
            components={{ IndicatorSeparator: null }}
            closeMenuOnSelect={true}
            blurInputOnSelect={false}
            clearable={true}
            value={''}
          />
            <TickerSelection />
        </div>
        <div className='col-sm-12 visible-xs visible-sm'>&nbsp;</div>
        {/* 
        <div className="col-lg-2 col-md-2 input-overflow-fix">
          <button disabled={!this.state.selectedFunds} onClick={this.handleSubmit} className={this.state.selectedFunds ? 'enabled' : 'disabled'}>{i18n.t('analyze-funds')}</button>
        </div>
        */}
        {showUpload &&
          <div className="col-lg-3 col-md-4">
            <div className='row'>
              <div className="upload col-xs-6">
                <label title='Upload an Excel file with tickers in the first column, or use our template.' htmlFor="upload-excel">
                  Upload Portfolio
                </label>
                <input
                  id="upload-excel"
                  type="file"
                  accept=".xls, .xlsx, .csv"
                  onChange={this.handleUpload} />
              </div>
              <div className="template col-xs-6">
                <a title='Download an example Excel template you can update with your tickers.' href='https://www.wisdomtree.com/-/media/us-media-files/advisor-solutions/digital-portfolio-developer/xls/capgainstemplate.xlsx' _target='blank'>Download Template</a>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }

}

FundSelector.propTypes = {
  /**
   * Function that the ANALYZE button will call when pushed
   */
  submitFundsToAnalyze: PropTypes.func.isRequired,
  /**
   * List of initial tickers to be loaded on start
   */
  initialTickers: PropTypes.array,
  /**
   * URL of the typeahead API endpoint. This is typically
   * DataSpanAPI
   */
  typeaheadUrl: PropTypes.string.isRequired,
  /**
   * URL of the ticker name checking API endpoint. This will check a list
   * from an Excel file and validate that the tickers are valid. This is typically
   * DataSpanAPI
   */
  tickerNamesUrl: PropTypes.string.isRequired,
  /**
   * The region to load the typeahead for (e.g., US)
   */
  wtRegion: PropTypes.string.isRequired,
  /**
   * The list of funds kept by the calling component so the FundSelector can remove
   * duplicates
   */
  currentFunds: PropTypes.array,
  /**
   * Whether to show the upload / template or not, defaults to true
   */
  showUpload: PropTypes.bool,
  /**
   * Maximum number of funds you can select
   */
  maxFunds: PropTypes.number,
};

FundSelector.defaultProps = {
  submitFundsToAnalyze: (selectedFunds) => { },
  initialTickers: [],
  typeaheadUrl: 'https://dataspanapi.wisdomtree.com/capgains/typeahead/',
  tickerNamesUrl: 'https://dataspanapi.wisdomtree.com/capgains/ticker_names/',
  wtRegion: 'US',
  currentFunds: [],
  showUpload: true,
  maxFunds: -1,
};

function mapStateToProps(state) {
  return {
    tickerSearch: state.params.tickerSearch,
    screenedFunds: state.params.screenedFunds,
  }
}

export default connect(mapStateToProps, {
  addScreenedFund,
  updateSearchTicker,
})(FundSelector);